module.exports = __webpack_public_path__ + "static/assets/a0204dc565bbe89f329535085cf1b98d.png";